'use strict';

angular.module('app.core', [])
    .value('PageValues', {
        'title': null,
        'description': null,
        'loading': false,
        "pragmaHeaderValue":"akamai-x-cache-on, akamai-x-cache-remote-on, akamai-x-check-cacheable, akamai-x-get-cache-key, akamai-x-get-extracted-values,akamai-x-get-nonces, akamai-x-get-ssl-client-session-id, akamai-x-get-true-cache-key, akamai-x-serial-no, akamai-x-get-request-id,akamai-x-feo-trace/",
        envs : {
                prod: {
                    host: ['fast.cvsspecialty.com']
                },
                sit1: {
                    host: ['sit1fast.cvsspecialty.com']
                },
                sit2: {
                    host: ['sit2fast.cvsspecialty.com']
                },
                sit3: {
                    host: ['sit3fast.cvsspecialty.com']
                },
                dev1: {
                    host: ['dev1fast.cvsspecialty.com']
                },
                dev2: {
                    host: ['dev2fast.cvsspecialty.com']
                },
                dev3: {
                    host: ['dev3fast.cvsspecialty.com']
                },
                local:{
                    host:['localhost']
                },
                stp: {
                    host: ['stpfast.cvsspecialty.com']
                }
        },
        appConfigs : {
            dev1: {
                apiURL: "https://dev1fast.cvsspecialty.com/api",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://dev1www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://dev1www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://dev1www.cvsspecialty.com",
                env:'dev1',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://dev1depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            dev2: {
                apiURL:"https://devservices-west.caremark.com:11099",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://dev2www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://dev2www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://dev2www.cvsspecialty.com",
                env:'dev2',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://dev2depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            dev3: {
                apiURL: "https://dev3fast.cvsspecialty.com/api",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://dev3www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://dev3www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://dev3www.cvsspecialty.com",
                env:'dev3',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://dev3depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            sit1: {
                apiURL:"https://sit1fast.cvsspecialty.com/api",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://sit1www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://sit1www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://sit1www.cvsspecialty.com",
                env:'sit1',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            sit2: {
                apiURL:"https://sit2fast.cvsspecialty.com/api",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://sit2www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://sit2www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://sit2www.cvsspecialty.com",
                env:'sit2',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit2depservices.cvs.com',
                },
                pbm_HEE_ServicesConfig:{
                    //"apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "apiKey": "769c71df-fd85-4645-92e0-b8003a8a4ef3",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            sit3: {
                apiURL:"https://sit3fast.cvsspecialty.com/api",
                apiKey: "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                ngxPortalUrl: "https://sit3www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://sit3www.cvsspecialty.com/FASTPROXY/",
                parentHost: "https://sit3www.cvsspecialty.com",
                env:'sit3',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit3depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                   
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            prod: {
                apiURL: "https://fast.cvsspecialty.com/api",
                apiKey: "a2ff75c6-2da7-4299-929d-d670d827ab4a",
                ngxPortalUrl: "https://cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://cvsspecialty.com/FASTPROXY/",
                parentHost: "https://www.cvsspecialty.com",
                env:'prod',
                depServicesConfig: {
                    "apiKey": "a2ff75c6-2da7-4299-929d-d670d827ab4a",
                    "serviceURL": 'https://depservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                   // "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                   //"serviceURL": 'https://sit1pbmservices.caremark.com',
                    "apiKey": "mm56884e-d777-4f52-b9e5-38e49c0b3e72",
                    "serviceURL": 'https://pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                     "apiKey": "ad4154dd-88b4-451c-81a2-4fa49da9cdba"
                }
            },
            stp: {
                apiURL: "https://fast.cvsspecialty.com/api",
                apiKey: "a2ff75c6-2da7-4299-929d-d670d827ab4a",
                ngxPortalUrl: "https://stp.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://stp.cvsspecialty.com/FASTPROXY/",
                env:'stp',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://stpdepservices.cvs.com'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            },
            local:{
                apiURL: "http://localhost:14510",
                apiKey: "a2ff75c6-2da7-4299-929d-d670d827ab4a",
                ngxPortalUrl: "https://sit2www.cvsspecialty.com/digital-fastproxy/",
                portalUrl:"https://sit2www.cvsspecialty.com/FASTPROXY/",
                env:'local',
                depServicesConfig: {
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'http://localhost:14510'
                },
                pbm_HEE_ServicesConfig:{
                    "apiKey": "2e77f5eb-016f-44a6-8d73-d5f2e6a01a54",
                    "serviceURL": 'https://sit1pbmservices.caremark.com',
                },
                newDeeplinkServiceConfig:{
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3"
               }
            }
        },
        wcm:{
            securechat: {"tapStreamUrl":"http://sit2ddl.cvsspecialty.com/srxredir-1"
            },
            siteMinderURL:"siteminderagent/forms/login.fcc",
            navigationUrl:{
                "qr_unregistered":"quickregistration/?REDIRECTTO=",
                //"qr_registered":"authentication/#/login?REDIRECTTO=",
                "qr_registered":"authentication/?REDIRECTTO=",
                "classic_login":"authentication/#/login?REDIRECTTO=",
                "classic_registration":"registration/#/?REDIRECTTO=",
                "fastproxy_qr_unregistered":"quickregistration/?REDIRECTTO=",
                "digital_fastproxy_registered":"specialty/#/login?REDIRECTTO="
            }
        },
        defaultEnv:'prod',
        routeParam:"web",
        redirectToComponent: [
            {
                campaign: "splty",
                navigationUrl: "liveChat&campaignID=",
                digitalFastProxy: true,
                skipMessageId: true
            }
        ]
    });
